import React, { useState, useEffect, useCallback } from 'react';
import styled from 'styled-components';
import axioPath from '../../../api/axioPath';
import { connect, useDispatch, useSelector } from 'react-redux';
import AlertModal from 'web/components/AlertModal';
import FileInput from 'web/components/form-elements/FileInput';
import MultipleFileInput from 'web/components/form-elements/MultipleFileInput';
import AddAPhotoOutlinedIcon from '@material-ui/icons/AddAPhotoOutlined';
import {
  uploadSpecification,
} from 'redux/actions/postLoad';

const UploadSpecification = ({ name, props, ProfileName, imageArrState, CompanyName, pageType, fileArr, acceptFiles, imageLoadCallBack, callBackFun, pageLanguageContents }) => {
  const [imgState, setImgState] = useState([]);
  return (
    <>
      <Container>
        <MultipleFileInput
          name={name}
          props={props}
          acceptFiles={
            acceptFiles
              ? acceptFiles
              : "image/png,image/jpeg,image/gif,application/pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
          }
          errorMsg={
            acceptFiles
              ? name === "bolDocument" ? "File type must be .PNG, .JPG, .PDF" : name === "uploadPalletInventoryImg" ? "File type must be .PNG, .JPG or .GIF" : "File extension must be excel"
              : "File extension must be jpeg, png, gif, pdf, excel,doc and docx"
          }
          placeholder={pageLanguageContents?.Location_Contents[26]?.References}
          attachOption="multiple"
          fileArr={fileArr}
          btnTxt={acceptFiles ? name === "bolDocument" ? (pageLanguageContents?.Location_Contents[25]?.UploadHere) : (pageLanguageContents?.Location_Contents[13]?.Template_Title) : ""}
          imageLoadCallBack={(imageArr) => {
            imageLoadCallBack(imageArr);
            setImgState(imageArr);
          }}
          callBackFun={(val) => {
            callBackFun(val)
          }}
          onChange={(files) => { }}
          clickHandler={(value) => { }}
        />
      </Container>

      <DesTag className="note">
        {name === 'editTaxExemption' && imgState.length === 0 ?
          '' : name === "bolDocument" ? <dd>PDF,PNG,JPG, docx, doc and GIF is allowed.</dd>
            : name === "taxExemption" ? <dd>Maximum 1 file can be uploaded (Should not exceed 5 MB)</dd>
              : name === "uploadPalletInventoryImg" ? <dd>Maximum 1 image can be uploaded (Should not exceed 5 MB)</dd>
                : name === "drivingLicenseDoc" ? <dd>Maximum 1 file can be uploaded (Should not exceed 5 MB)</dd>
                  : <dd>Maximum 3 files can be uploaded (Should not exceed 5 MB)</dd>}

      </DesTag>
    </>
  );
}

export default UploadSpecification;

const Container = styled.div`
    text-align: center;
    label.uploadPhoto {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        margin: 0;
        gap: 15px;
        > div {
            display: flex;
            align-items: center;
            font-size: 14px;
            border: 2px solid #61b01f;
            padding: 3px 12px;
            border-radius: 20px;
            margin-top:10px;
            max-width: 100%;
            p {
                white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
            }
        }
        svg {
                width: 18px;
                height: 18px;
                margin-left: 5px;
                cursor: pointer;
        }
}
`
const DesTag = styled.div`
  color: black;
  font-style: italic;
  font-size: 12px;
`;

const Upload = styled.div`
    flex: unset;
    position: absolute;
    right: 0;
    left: 0 ma;
    left: 0;
    margin: 0 auto;
    max-width: 110px;
    top: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    cursor:pointer;
    svg {
        font-size: 40px;
        color: #fff;
        background: #00000075;
        padding: 5px;
        border-radius: 50%;
    }
`
const InputFile = styled.div`
   display:none;
`
const PictureBox = styled.div`
    padding: 15px;
    background: linear-gradient(
0deg
,#fff 59%,#414141 60%);
    border-radius: 5px 5px 0 0;
    img {
        width: 120px;
        height: 120px;
        border-radius: 50%;
        border: 4px solid #ffffff;
        overflow: hidden;
        object-fit: cover;

    }
`
const ProfileData = styled.div``